module.exports = __webpack_public_path__ + "media/images/epub_logo_color-8ebf6ad699376cdc0f727e0103541532.svg";